import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCO9CFS5_YwttUKBNlUG09ZFbC2mLDwjbY",
  authDomain: "smb-admin-bd32d.firebaseapp.com",
  projectId: "smb-admin-bd32d",
  storageBucket: "smb-admin-bd32d.appspot.com",
  messagingSenderId: "XXXX",
  appId: "XXXX"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);